import { Navigate } from "react-router-dom"

import { CALL_PAGE } from "./common/constants"

import { createPsyCallPath } from "modules/Call/routing"
import { CallStatus } from "modules/Call/queries"
import { CallRedirectFunction } from "modules/Call/common/types"

function PsyAccountRedirect() {
    return <Navigate to="/psychologist-account" replace />
}

function LobbyRedirect({ bookingHash }: { bookingHash: string }) {
    return <Navigate to={createPsyCallPath(`/lobby/${bookingHash}`)} replace />
}

function EndedRedirect({ bookingHash }: { bookingHash: string }) {
    return <Navigate to={createPsyCallPath(`/ended/${bookingHash}`)} replace />
}

/**
 * Возвращает редирект на нужную страницу в зависимости от статуса звонка и текущей страницы.
 * Если страница и статус совпадают, то редирект не нужен и возвращается undefined.
 */
export function resolveRedirect(
    callStatus: CallStatus,
    page: CALL_PAGE
): CallRedirectFunction | undefined {
    switch (callStatus) {
        case "NEW":
            return PsyAccountRedirect
        case "UPCOMING":
            return page === CALL_PAGE.LOBBY ? undefined : LobbyRedirect
        case "CURRENT":
        case "STARTED":
            return page === CALL_PAGE.ROOM || page === CALL_PAGE.LOBBY ? undefined : LobbyRedirect
        case "ENDED":
        case "FEEDBACK_RECEIVED":
            return page === CALL_PAGE.ENDED ? undefined : EndedRedirect
        case "PASSED":
            return PsyAccountRedirect
    }
}
